import { StateCreator } from 'zustand';
import { createAppStore } from '@marriott/mi-store-utils';
import { FEATURE_FLAGS } from '@marriott/mi-feature-flag-utils';

type DttState = {
  isDtt: boolean;
  isDefaultDatesAllowedInDttUxlInput: boolean;
  featureFlagLogo: boolean;
  isDttSwpGroupsEnabled: boolean;
  isNextGenSearchFormEnabled: boolean;
  isBranchIoAppDownloadEnabled: boolean;
  isSwp: boolean;
  isCorporateBranchIoEnabled?: boolean;
  isPickupStatsAlertsEnabled?: boolean;
};

type DttActions = {
  setDttFlags: (dttFlags: { [key in FEATURE_FLAGS]?: string | boolean | Record<string, unknown> }) => void;
  setIsSwp: (isSwp: boolean) => void;
};

const initialState: DttState = {
  isDtt: false,
  isDefaultDatesAllowedInDttUxlInput: false,
  featureFlagLogo: false,
  isDttSwpGroupsEnabled: false,
  isNextGenSearchFormEnabled: false,
  isBranchIoAppDownloadEnabled: false,
  isSwp: false,
  isCorporateBranchIoEnabled: false,
  isPickupStatsAlertsEnabled: false,
};

export const dttStore: StateCreator<DttState & DttActions> = set => {
  return {
    ...initialState,

    setDttFlags: (dttFlags: { [key in FEATURE_FLAGS]?: string | boolean | Record<string, unknown> }) => {
      set(prevState => {
        const isDtt = !!dttFlags?.[FEATURE_FLAGS.EXPERIENCE_MCOM_DTT_GROUP];
        return {
          ...prevState,
          isDtt,
          isDefaultDatesAllowedInDttUxlInput:
            isDtt && !!dttFlags?.[FEATURE_FLAGS.EXPERIENCE_MCOM_DTT_GROUP_UXL_ALLOW_DEFAULT_DATES],
          featureFlagLogo: !!dttFlags?.[FEATURE_FLAGS.EXPERIENCE_MCOM_LOGO_AUTOMATION],
          isDttSwpGroupsEnabled: !!dttFlags?.[FEATURE_FLAGS.EXPERIENCE_MCOM_DTT_SWP_GROUPS],
          isNextGenSearchFormEnabled: !!dttFlags?.[FEATURE_FLAGS.EXPERIENCE_MCOM_GROUPS_NEXT_GEN_SEARCH_FORM],
          isBranchIoAppDownloadEnabled:
            !!dttFlags?.[FEATURE_FLAGS.EXPERIENCE_MCOM_GROUPS_BRANCH_IO_APP_DOWNLOAD_ENABLED],
          isCorporateBranchIoEnabled: !!dttFlags?.[FEATURE_FLAGS.EXPERIENCE_MCOM_GROUPS_BRANCH_IO_CORP_ENABLED],
          isPickupStatsAlertsEnabled: !!dttFlags?.[FEATURE_FLAGS.EXPERIENCE_MCOM_GROUPS_PICKUP_STATS_ALERTS_ENABLED],
        };
      });
    },

    setIsSwp: (isSwp: boolean) => {
      set(prevState => ({ ...prevState, isSwp }));
    },
  };
};

export const useDttStore = createAppStore(dttStore);
